import Css from "./style.module.scss";

import DropDownContext from "nlib/ui/DropDown/DropDownContext";
import React, { useCallback, useContext, useRef } from "react";
import classNames from "classnames";

const DropDownMenuItem = (props) => {
  const {
    value,
    icon: Icon,
    disabled,
    selected,
    children,
    primary,
    danger,
    className,
    closeOnClick = true,
    onClick,
    ...restProps
  } = props;

  const itemRef = useRef();

  const context = useContext(DropDownContext);

  const handleClick = useCallback((event) => {
    if (onClick && !disabled) onClick(value, event);
    if (!context || !closeOnClick) return;

    const { setOpened } = context;

    setOpened(false);
  }, [value, disabled, context, closeOnClick, onClick]);

  return (
    <div
      {...restProps}
      ref={itemRef}
      className={classNames(
        Css.dropDownMenuItem,
        selected && Css.selected,
        onClick && Css.clickable,
        primary && Css.primary,
        danger && Css.danger,
        className
      )}
      disabled={disabled}
      onClick={handleClick}>
      {!!Icon && <Icon weight="bold" className={Css.icon} />}
      {children}
    </div>
  );
};

export default React.memo(DropDownMenuItem);
